import { __ } from "@wordpress/i18n";
import {
  ToggleControl,
  Button,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from "@wordpress/components";
import { useState, useMemo } from "@wordpress/element";
import { __experimentalSpacingSizesControl as SpacingSizesControl } from "@wordpress/block-editor";
import IconsModal from "../IconsModal";
import "./index.scss";

const IconDisplay = ({
  enabled,
  name,
  type,
  position,
  size,
  gap,
  handleChangeAttributes,
  buttonLabel = null,
}) => {
  const [isIconsModalOpen, setIsIconsModalOpen] = useState(false);
  const previewIconHtml = useMemo(() => {
    if ((enabled != null && !enabled) || !name || !type) {
      return "";
    }

    try {
      let html = (
        <span
          className={`brandy-preview-icon-content`}
          style={{ color: "inherit" }}
        >
          <i
            className={`ph${type !== "regular" ? "-" + type : ""} ph-${name}`}
            style={{ fontSize: "24px" }}
          ></i>
        </span>
      );

      return html;
    } catch (error) {
      return "";
    }
  }, [enabled, name, type]);

  return (
    <>
      {enabled != null && (
        <ToggleControl
          label={__("Use icon", "brandy-blocks")}
          checked={enabled}
          onChange={(value) => {
            handleChangeAttributes({
              enabled: value,
              ...(value && !name ? { name: "heart", type: "regular" } : {}),
            });
          }}
        />
      )}
      {(enabled || enabled == null) && (
        <>
          <Button
            variant="secondary"
            onClick={() => setIsIconsModalOpen(true)}
            style={{ marginBottom: "10px", width: "100%" }}
            className="brandy-select-icon-button"
          >
            {name
              ? buttonLabel !== null
                ? `Change ${buttonLabel}`
                : __("Change Icon", "brandy-blocks")
              : buttonLabel !== null
              ? `Select ${buttonLabel}`
              : __("Select Icon", "brandy-blocks")}
          </Button>
          {name && (
            <div
              style={{
                marginBottom: "10px",
                padding: "10px",
                textAlign: "center",
                background: "#f4f4f4",
                borderRadius: "4px",
              }}
            >
              <div style={{ display: "inline-block" }}>{previewIconHtml}</div>
            </div>
          )}
          {position != null && (
            <div className="components-base-control">
              <ToggleGroupControl
                label={__("Icon Position", "brandy-blocks")}
                value={position || "left"}
                onChange={(value) =>
                  handleChangeAttributes({ position: value })
                }
                isBlock
              >
                <ToggleGroupControlOption
                  value="left"
                  label={__("Left", "brandy-blocks")}
                />
                <ToggleGroupControlOption
                  value="right"
                  label={__("Right", "brandy-blocks")}
                />
              </ToggleGroupControl>
            </div>
          )}
          {size != null && (
            <SpacingSizesControl
              label={__("Icon size")}
              min={0}
              value={size}
              onChange={(value) => handleChangeAttributes({ size: value.top })}
              showSideInLabel={false}
              sides={["top"]}
              values={{ top: size }}
              allowReset={false}
            />
          )}

          {gap != null && (
            <SpacingSizesControl
              label={__("Icon gap")}
              min={0}
              value={gap}
              onChange={(value) => handleChangeAttributes({ gap: value.top })}
              showSideInLabel={false}
              sides={["top"]}
              values={{ top: gap }}
              allowReset={false}
              help={__("Space between text and icon", "brandy-blocks")}
            />
          )}
        </>
      )}

      <IconsModal
        isIconsModalOpen={isIconsModalOpen}
        setIsIconsModalOpen={setIsIconsModalOpen}
        icon={{
          name: name,
          type: type,
        }}
        setAttributes={(newAttrs) => {
          handleChangeAttributes(newAttrs);
        }}
      />
    </>
  );
};

export default IconDisplay;
